// authService.js - Handles authentication logic

export const isAuthenticated = () => {
    return localStorage.getItem("isAuthenticated") === "true";
  };
  
  export const loginUser = (identifier, password) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (
          (identifier === "admin@idecisioncrm.com" || identifier === "staff123") &&
          password === "password"
        ) {
          localStorage.setItem("isAuthenticated", "true");
          resolve(true);
        } else {
          reject("Invalid User ID / Email or Password");
        }
      }, 1000);
    });
  };
  
  export const logoutUser = () => {
    console.log("Logging out..."); // Debugging message
    localStorage.removeItem("isAuthenticated"); // Remove authentication flag
    setTimeout(() => {
      window.location.href = "/login"; // Redirect to login page
    }, 500); // Short delay to ensure storage clears
  };